const actions = {
  FETCH_USERS: 'FETCH_USERS',
  FETCH_USERS_SUCCESS: 'FETCH_USERS_SUCCESS',
  FETCH_USERS_ERROR: 'FETCH_USERS_ERROR',
  USER_SET: 'user/SET_VALUE',
  //    USER_ADD: 'user/ADD_VALUE',
  USER_DEL: 'user/DEL_VALUE',
  USER_SUCCESS: 'user/SUCCESS',
  USER_ERROR: 'user/ERROR',
}

export default actions
